import React from 'react';

import authService from 'Lib/auth/AuthService';

const Logout = () => {
    React.useEffect(() => {
        authService.logout();
    }, []);

    // Logout component does not render anything
    return null;
};

export default Logout;